import { PixelPlaceholderLoader } from "@similarweb/ui-components";
import { StyledPreloaderWrapper, StyledLoaderRow } from "./styles";

export const ExportTablePreloader = ({ rowsNum = 20 }: { rowsNum?: number }) => {
    const loaderItems = [];

    for (let index = 0; index <= rowsNum; index++) {
        loaderItems.push(
            <StyledLoaderRow>
                <PixelPlaceholderLoader
                    width="97%"
                    height={20}
                />
            </StyledLoaderRow>,
        );
    }

    return (
        <StyledPreloaderWrapper style={{ height: "100%", width: "100%", padding: "20px" }}>
            {...loaderItems}
        </StyledPreloaderWrapper>
    );
};
